import React, { Component } from 'react'
import { connect } from 'react-redux'
import VisibilitySensor from 'react-visibility-sensor'
import ImageLoader from 'alt-imageloader'
import Title from '../components/Title.jsx'
import Button from '../components/Button.jsx'
import AnimatedCounter from '../components/AnimatedCounter.jsx'

class ServicesPoolContainer extends Component {
    state = {
        activeTab: 0,
        startAnimation: false
    }

    setActiveTab = (key) => {
        this.setState({
            activeTab: key
        })
    }

    onVisibilityChange = (isVisible) => {
        if (isVisible) {
            this.setState({
                startAnimation: true
            })
        }
    }

    render() {
        const tabItems = this.props.langData.items.map((val, key) => {
            let activeTabClass = ''
            let activeTabClassResp = ''
            if (key === this.state.activeTab) {
                activeTabClass = 'pool-tabs__item-text--active'
                activeTabClassResp = 'pool-tabs__item--resp-active'
            }
            return (
                <div
                    className={`pool-tabs__item ${activeTabClassResp}`}
                    key={key}
                    onClick={this.setActiveTab.bind(null, key)}
                >
                    <span className={`pool-tabs__item-text subheader hidden-sm hidden-xs ${activeTabClass}`}>
                        {val.title}
                    </span>
                </div>
            )
        })

        const tabData = this.props.langData.items[this.state.activeTab]

        const poolConstText = (
            <div className="pool-text">
                <span className="pool-text__title hidden-md hidden-lg hidden-xl">
                    {`${this.state.activeTab + 1} `}.
                </span>
                <span className="pool-text__title">{tabData.title}</span>
                <p className="paragraph pool-text__text">{tabData.text}</p>
            </div>
        )

        const infoItems = this.props.langData.infoItems.map((val, key) => (
            <div className="info-items__item" key={key}>
                <AnimatedCounter
                    endNumber={val.num}
                    transitionDuration={2}
                    startAnimation={this.state.startAnimation}
                    prefix={val.frontUnit}
                    sufix={val.unit}
                />
                <p className="paragraph info-items__item-text">{val.text}</p>
            </div>
        ))

        return (
            <div className="pool-const section-spacing">
                <div id="izgradnjabazena" className="container">
                    <Title
                        className="header1--center header1--small header1--small-margin"
                        title={this.props.langData.title}
                    />
                    <div className="pool-const-subtitle">
                        <p className="paragraph ">{this.props.langData.text}</p>
                    </div>
                    <div className="row pool-const-row">
                        <div className="col-md-12">
                            <div className="pool-tabs">
                                {tabItems}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div
                                className="pool-img"
                            >
                                <ImageLoader
                                    background={`/images/el/${tabData.img}`}
                                    className="alt-imageloader--gray"
                                    animationDelay={200}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            {poolConstText}
                        </div>
                        <div className="col-md-12">
                            <VisibilitySensor
                                onChange={this.onVisibilityChange}
                                active={!this.state.startAnimation}
                            />
                            <div className="info-items">
                                {infoItems}
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="pool-const-btn">
                                <div className="pool-const-btn__line"></div>
                                <div className="pool-const-btn__outer">
                                    <Button
                                        type="arrow"
                                        text={this.props.langData.btnText}
                                        link="/kontakt/1"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    langData: state.langData.services.poolConstruction
})

export default connect(mapStateToProps)(ServicesPoolContainer)



// WEBPACK FOOTER //
// ./src/scripts/containers/ServicesPoolContainer.jsx